import {useState} from "react";
import {RsAddressCandidate} from "../../api/dto/RsAddressCandidate";
import {AddressService} from "../../service/AddressService";

export const SearchAddressViewModel = () => {

    const [addressCandidates, setAddressCandidates] = useState<RsAddressCandidate[]>([]);
    const [loading, setLoading] = useState(false);

    const searchAddresses = async (query: string, verificationId: string) => {
        setLoading(true)
        const result = await AddressService.getInstance().search(query, verificationId)
        setAddressCandidates(result)
        setLoading(false)
    }

    return {
        addressCandidates,
        loading,
        searchAddresses
    }

}